(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7109],{

/***/ 6913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": function() { return /* binding */ BannerSize; },
/* harmony export */   "Rt": function() { return /* binding */ BannerKey; },
/* harmony export */   "fg": function() { return /* binding */ KeyBanner; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11717);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54909);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61871);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24123);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45432);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30259);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96964);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3263);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98379);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81946);
/* harmony import */ var _layout_Border__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95567);
/* harmony import */ var _EFinderImage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92145);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    max-width: 500px;\n    margin: 0 auto;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  ",
        " {\n    max-width: 560px;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var BannerSize;
(function(BannerSize) {
    BannerSize["curation"] = "38.8889%";
    BannerSize["promotion"] = "20%";
    BannerSize["home"] = "56.25%";
    BannerSize["playHome"] = "48%";
})(BannerSize || (BannerSize = {}));
var bannerItemCSS = function(size) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)(_templateObject(), typeof size === "number" ? "".concat(size, "px") : size);
};
var videoCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)(_templateObject1());
var responsiveBannerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)(_templateObject2(), _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .media.desktop */ .BC.desktop);
var BannerVideo = function(param) {
    var active = param.active, autoPlay = param.autoPlay, loop = param.loop, onEnded = param.onEnded, poster = param.poster, video = param.video;
    var ref;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var src = (ref = video.attachment) === null || ref === void 0 ? void 0 : ref.url;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var videoElement = videoRef.current;
        if (!videoElement) {
            return;
        }
        if (!active || !autoPlay) {
            videoElement.pause();
            if (!active && videoElement.currentTime !== 0) {
                videoElement.currentTime = 0;
            }
            return;
        }
        videoElement.play().catch(function() {
            return undefined;
        });
    }, [
        active,
        autoPlay,
        src
    ]);
    if (!src) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("video", {
        ref: videoRef,
        css: videoCSS,
        src: src,
        poster: poster,
        muted: true,
        playsInline: true,
        loop: loop,
        onEnded: onEnded,
        preload: "auto"
    });
};
var ref, ref1;
var getBannerHeight = function(item) {
    var ref2, ref3, ref4, ref5;
    return ((ref1 = (ref = (ref2 = item.image) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attachment) === null || ref3 === void 0 ? void 0 : ref3.height) !== null && ref !== void 0 ? ref : (ref4 = item.video) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attachment) === null || ref5 === void 0 ? void 0 : ref5.height) !== null && ref1 !== void 0 ? ref1 : 150) / 3;
};
var hasVideoSource = function(item) {
    var ref, ref1;
    return !!((ref = item.video) === null || ref === void 0 ? void 0 : (ref1 = ref.attachment) === null || ref1 === void 0 ? void 0 : ref1.url);
};
var AUTO_PLAY_INTERVAL_MS = 3000;
var Banner = function(param) {
    var name = param.name, _isBorder = param.isBorder, isBorder = _isBorder === void 0 ? true : _isBorder, size = param.size, items = param.items, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? true : _autoPlay, _allowVideo = param.allowVideo, allowVideo = _allowVideo === void 0 ? false : _allowVideo, _videoLoadEnabled = param.videoLoadEnabled, videoLoadEnabled = _videoLoadEnabled === void 0 ? true : _videoLoadEnabled, _imageHeight = param.imageHeight, imageHeight = _imageHeight === void 0 ? _EFinderImage__WEBPACK_IMPORTED_MODULE_12__/* .EFinderImageSizes.banner */ .ny.banner : _imageHeight;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_6__/* .useGlobalContext */ .bN)().platform;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_10__/* .useWebView */ .B9)().web;
    var firebase = (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .useAnalytics */ .z$)().firebase;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), retainedVideoIds = ref1[0], setRetainedVideoIds = ref1[1];
    var hasVideoItems = allowVideo && items.some(function(item) {
        return item.mediaType === "video" && hasVideoSource(item);
    });
    var activeItem = items[activeIndex];
    var isActiveVideoMounted = videoLoadEnabled && !!activeItem && allowVideo && activeItem.mediaType === "video" && hasVideoSource(activeItem);
    var advanceActiveItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(expectedIndex) {
        setActiveIndex(function(currentIndex) {
            if (currentIndex !== expectedIndex) {
                return currentIndex;
            }
            return (currentIndex + 1) % items.length;
        });
    }, [
        items.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (activeIndex >= items.length) {
            setActiveIndex(0);
        }
    }, [
        activeIndex,
        items.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isActiveVideoMounted || !activeItem) {
            return;
        }
        setRetainedVideoIds(function(currentIds) {
            return currentIds.includes(activeItem.id) ? currentIds : _toConsumableArray(currentIds).concat([
                activeItem.id
            ]);
        });
    }, [
        activeItem,
        isActiveVideoMounted
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var currentVideoIds = new Set(items.filter(function(item) {
            return item.mediaType === "video" && hasVideoSource(item);
        }).map(function(item) {
            return item.id;
        }));
        setRetainedVideoIds(function(currentIds) {
            var validIds = currentIds.filter(function(id) {
                return currentVideoIds.has(id);
            });
            return validIds.length === currentIds.length ? currentIds : validIds;
        });
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var shouldAutoAdvanceWithTimer = autoPlay && hasVideoItems && items.length > 1 && !!activeItem && !isActiveVideoMounted;
        if (!shouldAutoAdvanceWithTimer) {
            return;
        }
        var timeoutId = window.setTimeout(function() {
            return advanceActiveItem(activeIndex);
        }, AUTO_PLAY_INTERVAL_MS);
        return function() {
            return window.clearTimeout(timeoutId);
        };
    }, [
        activeIndex,
        activeItem,
        advanceActiveItem,
        autoPlay,
        hasVideoItems,
        isActiveVideoMounted,
        items.length, 
    ]);
    if (items.length === 0) {
        return null;
    }
    var carouselAutoPlay = autoPlay && !hasVideoItems;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, {
        children: [
            isBorder && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_layout_Border__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                type: _layout_Border__WEBPACK_IMPORTED_MODULE_11__/* .BorderType.space */ .T.space
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__/* .Carousel */ .lr, {
                css: responsiveBannerCSS,
                autoPlay: carouselAutoPlay,
                selectedItem: activeIndex,
                showIndicators: items.length > 1,
                showThumbs: false,
                showStatus: false,
                showArrows: false,
                infiniteLoop: !hasVideoItems,
                emulateTouch: true,
                onChange: setActiveIndex,
                onClickItem: function(i) {
                    if (name === "play-full-screen=banner") {
                        firebase.logEvent("chatbot_click_play_curation", {
                            curation_view_type: "full_screen_banner"
                        });
                    }
                    var url = items[i].url;
                    if (url) {
                        if (platform === _constants__WEBPACK_IMPORTED_MODULE_5__/* .Platform.web */ .t4.web) {
                            router.push(url);
                        }
                        web.openUrl(url);
                    }
                },
                children: items.map(function(item, idx) {
                    var ref, ref1;
                    var image = item.image;
                    var video = allowVideo && item.mediaType === "video" ? item.video : undefined;
                    var isActive = idx === activeIndex;
                    var shouldMountVideo = videoLoadEnabled && !!(video === null || video === void 0 ? void 0 : (ref = video.attachment) === null || ref === void 0 ? void 0 : ref.url) && (isActive || retainedVideoIds.includes(item.id));
                    var shouldAutoAdvanceVideo = autoPlay && items.length > 1 && isActive;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", {
                        css: bannerItemCSS(size !== null && size !== void 0 ? size : getBannerHeight(item)),
                        children: shouldMountVideo && video ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(BannerVideo, {
                            active: isActive,
                            autoPlay: autoPlay,
                            loop: !shouldAutoAdvanceVideo,
                            onEnded: shouldAutoAdvanceVideo ? function() {
                                return advanceActiveItem(idx);
                            } : undefined,
                            poster: image === null || image === void 0 ? void 0 : (ref1 = image.attachment) === null || ref1 === void 0 ? void 0 : ref1.url,
                            video: video
                        }) : image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_EFinderImage__WEBPACK_IMPORTED_MODULE_12__/* .OptimizeEFinderImage */ .yK, {
                            image: image,
                            h: imageHeight,
                            loading: idx === 0 && priority ? "eager" : "lazy",
                            priority: idx === 0 && priority
                        })
                    }, "banner-".concat(name, "-").concat(item.id));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Banner);
var BannerKey;
(function(BannerKey) {
    BannerKey["story"] = "story";
    BannerKey["myStory"] = "my_story";
})(BannerKey || (BannerKey = {}));
var KeyBanner = function(param) {
    var bKey = param.bKey, size = param.size;
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        "banners",
        bKey
    ], function() {
        return (0,_api_common__WEBPACK_IMPORTED_MODULE_9__/* .fetchBanners */ .f8)(bKey);
    }, {
        suspense: false,
        staleTime: Infinity,
        cacheTime: Infinity
    });
    var data = query.data;
    if (!data) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Banner, {
        name: bKey,
        size: size,
        items: data
    });
};


/***/ }),

/***/ 95567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ BorderType; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71618);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-bottom-width: ",
        "px;\n  border-style: ",
        ";\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BorderType;
(function(BorderType) {
    BorderType["line"] = "line";
    BorderType["space"] = "space";
})(BorderType || (BorderType = {}));
var borderCSS = function(color, style, size) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), size, style, color);
};
var Border = function(param) {
    var className = param.className, color = param.color, _type = param.type, type = _type === void 0 ? BorderType.line : _type, _style = param.style, style = _style === void 0 ? "solid" : _style;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.u)();
    if (type === BorderType.space) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            css: borderCSS(color !== null && color !== void 0 ? color : theme.border.space, style, 8),
            className: className
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: borderCSS(color !== null && color !== void 0 ? color : theme.border.lightest, style, 1),
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Border);


/***/ }),

/***/ 12293:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 47304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSum = __webpack_require__(12293),
    identity = __webpack_require__(37174);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),

/***/ 74001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

}]);